<template>
 <div class="mode">
    <i
      class="fa fa-moon-o"
      v-show="isLightMode"
      @click="customizeMixLayout('dark-only')"
    ></i>
    <i
      class="fa fa-lightbulb-o"
      v-show="isDarkMode"
      @click="customizeMixLayout('light-only')"
    ></i>
  </div>
</template>

<script>
  export default {

    data() {
      return {
        darkMode: false,
        mixLayout: 'light-only',
      };
    },
    computed: {
      isLightMode() {
        const v = this.mixLayout || localStorage.getItem('layoutVersion') || document.body.className || 'light';
        return v !== 'dark-only';
      },
      isDarkMode() {
        const v = this.mixLayout || localStorage.getItem('layoutVersion') || document.body.className || '';
        return v === 'dark-only';
      },
    },
    mounted() {
      this.mixLayout = localStorage.getItem('layoutVersion') || document.body.className || 'light-only';
    },
    methods: {
        customizeMixLayout(val) {
        this.mixLayout = val;
        this.$store.dispatch('layout/setLayout', val);
      },
    },
    
  };
</script>
